import { FC, ReactNode, useEffect, useState } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import { cn } from '@/lib/utils'

interface MarkdownMessageProps {
  content: string | ReactNode | null | undefined
  className?: string
}

const MarkdownMessage: FC<MarkdownMessageProps> = ({ content, className }) => {
  const [sanitizedHtml, setSanitizedHtml] = useState<string | null>(null)

  useEffect(() => {
    const processContent = async () => {
      if (!content || typeof content !== 'string') return

      const cleanedContent = content?.replace(/```(?:\w+)?\n([\s\S]*?)```/g, '$1')

      const rawHtml = await marked.parse(cleanedContent)
      const cleanHtml = DOMPurify.sanitize(rawHtml)

      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = cleanHtml

      tempDiv.querySelectorAll('a').forEach(anchor => {
        anchor.setAttribute('target', '_blank')
        anchor.setAttribute('rel', 'noopener noreferrer')
      })

      setSanitizedHtml(tempDiv.innerHTML)
    }

    processContent()
  }, [content])

  if (!sanitizedHtml) return null

  return <div className={cn('markdown-body', className)} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}

export default MarkdownMessage
